var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeftRight = function SvgArrowLeftRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.667 10.667V8L14 11.333l-3.333 3.334V12h-8v-1.333h8ZM5.333 1.333V4h8v1.334h-8V8L2 4.667l3.333-3.334Z",
    fill: "#74778E"
  })));
};
export default SvgArrowLeftRight;